import { LoginCard } from '@/components/layout/LoginCard';
import { Button, Form, FormInput, FormLabel, PasswordInput, StandaloneLink } from '@/components/wm';
import { apiRequest } from '@/utils/request';
import * as React from 'react';
import { useEffect, useState } from 'react';

export function LoginForm ({ onOtpRequest, onAlert, onForgotPassword }) {
    const
        [email, setEmail] = useState(''),
        [formFilled, setFormFilled] = useState(false),
        [loading, setLoading] = useState(false),
        [password, setPassword] = useState('');

    useEffect(() => {
        const formFilled = password !== '' && email !== '';

        setFormFilled(formFilled);
    }, [email, password]);

    const handleForgotPassword = () => {
        onForgotPassword(email);
    };

    const handleSubmit = async event => {
        event.preventDefault();
        setLoading(true);

        const data = {
            email,
            password
        };

        try {
            const response = await apiRequest('/login', 'POST', data);

            if (response.status === 200) {
                onOtpRequest(email, password);
            }
        } catch (err) {
            const errorMessage = err.response?.data?.error?.capitalize() || i18next.t('alert_boxes.error_occurred');

            onAlert(errorMessage, 'destructive', i18next.t('alert_boxes.failed'));
            setPassword('');
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 500);
        }
    };

    const handleSignup = async event => {
        event.preventDefault();
        Backbone.history.navigate('/signup', { trigger: true });
    };

    return (
        <LoginCard>
            <Form>
                <FormLabel htmlFor="email">{i18next.t('common.email')}</FormLabel>
                <FormInput
                    id="email"
                    onChange={e => setEmail(e.target.value)}
                    placeholder="m@example.com"
                    required
                    type="email"
                    value={email}
                />
                <FormLabel htmlFor="password">{i18next.t('common.password')}</FormLabel>
                <PasswordInput
                    id="password"
                    onChange={e => setPassword(e.target.value)}
                    required
                    value={password}
                />
                <Button className="tw-w-full" disabled={!formFilled} loading={loading} onClick={handleSubmit} type="submit" variant="secondary">
                    {i18next.t('ui.buttons.login')}
                </Button>
            </Form>
            <div className="tw-flex tw-justify-between tw-gap-2">
                <StandaloneLink onAction={handleForgotPassword} text={i18next.t('ui.passwords.forgot_password')}/>
                <StandaloneLink href="mailto:support@wisemetering.com" text={i18next.t('glossary.contact_us').capitalize()}/>
            </div>
            <div className="tw-w-full tw-bg-backgroundGrey tw-rounded-lg tw-border tw-border-solid tw-border-border tw-p-4 tw-mt-4">
                {i18next.t('users.new_to_wisemetering')}
                <a
                    aria-disabled={loading}
                    className={`tw-text-primary hover:tw-underline tw-cursor-pointer tw-font-bold tw-text-md tw-ml-2`}
                    onClick={handleSignup}
                >
                    {i18next.t('users.create_free_account_here')}
                </a>
            </div>
        </LoginCard>
    );
}
